import index from './policy.vue'
import Vue from '../../comm.js'
// import Vue from '../../commwh.js'

new Vue({
  el: '#app',
  template: "<index/>",
  components: {
    index
  },
})


// WEBPACK FOOTER //
// ./src/pages/landingPage/policy.js